<template>
  <div class="addProject">
    <div class="content_main">
      <!-- <div class="title">发布招商项目</div> -->
      <div class="main_content">
        <p>行业</p>
        <div class="mode1">
          <div class="chooseHy" @click="showHy">
            {{ cate_txt ? cate_txt : "你选的行业客户将看到你的项目..." }}
          </div>
        </div>
        <p>项目名称</p>
        <div class="mode1">
          <input placeholder="输入你的项目名称..." v-model="title" />
        </div>
        <p>项目亮点</p>
        <div class="mode1">
          <input
            placeholder="如:0投资,不存货,保底每月5000元..."
            v-model="describe"
          />
        </div>
        <p>项目介绍</p>
        <div class="mode1">
          <div class="jieshao">
            <textarea
              v-model="jieshao"
              maxlength="1000"
              placeholder="请输入项目的介绍,方便潜在客户快速了解..."
            ></textarea>
            <div class="addc">
              <div class="addico">
                <input type="file" class="file" @change="upImg" ref="file" />
                <img
                  src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_pico1.png"
                />
                <p>图片</p>
              </div>
              <!--  <div class="addico">
                <img
                  src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_pico2.png"
                />
                <p>文字</p>
              </div> -->
            </div>
          </div>
        </div>
        <div class="img" v-for="(item, index) in imgs">
          <img :src="item" />
          <div class="img_btn">
            <div class="item" @click="delimg(index)">
              <van-icon name="close" size=".32rem" color="#ffffff" />
              <span>删除图片</span>
            </div>
            <div class="item">
              <input
                type="file"
                class="file"
                @change="changeupImg($event, index)"
              />
              <van-icon name="replay" size=".32rem" color="#ffffff" />
              <span>替换图片</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <div class="footerBtn">
      <div class="fabuBtn" @click="getAddProjectNew">确定</div>
    </div>
    <!-- 选中行业 -->
    <div class="dialog chooseHyDialog" v-if="chooseHyDialog">
      <div class="hyContent">
        <div class="hangyeTitle">
          <span>行业</span>
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_pico3.png"
            @click="hideChooseHyDialog"
          />
        </div>
        <div class="hyAll">
          <div
            class="hangyeli"
            v-for="(item, index) in hangyeList"
            :key="index"
          >
            <div class="cat_title">{{ item.cat_title }}</div>
            <div class="lispan">
              <span
                v-for="(item2, index2) in item.child"
                :key="index2"
                @click="chooseli(item2.id, item2.cat_title)"
                :class="chkid == item2.id ? 'ackli' : ''"
                >{{ item2.cat_title }}</span
              >
            </div>
          </div>
        </div>
        <div class="yesBtn" @click="chooseHyes">确定</div>
      </div>
    </div>
    <div class="loadingBox" v-if="addLoading">
      <van-loading
        size="24px"
        vertical
        style="position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);"
        >上传中...</van-loading
      >
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from "vant";
import {
  getShare,
  getAddProjectNew,
  getArticleCateLstNew,
  getUploadImageNew,
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "addproject",
  components: {},
  props: {},
  data: function() {
    return {
      addLoading: false,
      chooseHyDialog: false,
      hangyeList: [],
      chkid: 0, //默认选中全行业
      chkTxt: "", //选中的行业文字
      cate_id: "", //行业id
      cate_txt: "", //行业id对应的文字
      title: "",
      describe: "",
      jieshao: "",
      details: "",
      imgs: [],
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    vm.setOpenShare();
    vm.getArticleCateLstNew();
  },
  methods: {
    //获取行业列表
    getArticleCateLstNew() {
      getArticleCateLstNew().then((res) => {
        this.hangyeList = res.data;
      });
    },
    //显示行业
    showHy() {
      this.chooseHyDialog = true;
    },
    hideChooseHyDialog() {
      this.chooseHyDialog = false;
    },
    // 选择行业
    chooseli(id, txt) {
      this.chkid = id;
      this.chkTxt = txt;
    },
    // 确定选择该行业
    chooseHyes() {
      this.cate_id = this.chkid;
      this.cate_txt = this.chkTxt;
      this.chooseHyDialog = false;
    },
    // 图片内容上传
    upImg(e) {
      let that = this;
      that.addLoading = true;
      var files = e.target.files[0];
      var formD1 = new FormData();
      formD1.append("file", e.target.files[0]);
      getUploadImageNew(formD1)
        .then((res) => {
          that.imgs.push(res.data.url);
          that.addLoading = false;
        })
        .catch((err) => {
          Toast("上传失败！");
          that.addLoading = false;
        });
    },
    changeupImg(e, index) {
      let that = this;
      that.addLoading = true;
      var files = e.target.files[0];
      var formD = new FormData();
      formD.append("file", e.target.files[0]);
      getUploadImageNew(formD)
        .then((res) => {
          that.imgs.splice(index, 1, res.data.url);
          that.addLoading = false;
        })
        .catch((err) => {
          Toast("上传失败！");
          that.addLoading = false;
        });
    },
    delimg(index) {
      this.imgs.splice(index, 1);
    },
    // 添加项目
    getAddProjectNew() {
      if (
        this.cate_id == "" ||
        this.cate_id == "undefined" ||
        this.cate_id == undefined
      ) {
        return Toast("务必选择行业！");
      }
      if (this.title.trim().length < 1) {
        return Toast("务必输入标题！");
      }
      if (this.describe.trim().length < 1) {
        return Toast("务必输入项目亮点！");
      }
      if (this.jieshao.trim().length < 1) {
        return Toast("务必输入项目介绍！");
      }
      this.details = {
        text: this.jieshao,
        img: this.imgs.join(","),
      };
      var data = {
        cate_id: this.cate_id,
        title: this.title,
        describe: this.describe,
        details: JSON.stringify(this.details),
      };
      console.log("data：", data);
      getAddProjectNew(data)
        .then((res) => {
          Toast(res.msg);
          setTimeout(function() {
            window.location.href = "/project/list";
          }, 1200);
        })
        .catch((err) => {
          Toast(err);
        });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jiaojiao.yanjiusuo.xyz",
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>

<style>
.addProject {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-height: 100vh;
}
.loadingBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.content_main {
  width: 100%;
  padding: 0 0.3rem;
  position: relative;
  background-color: #fff;
}
.title {
  font-size: 0.36rem;
  color: #000;
  line-height: 1rem;
}
.main_content {
  position: relative;
}
.main_content p {
  font-size: 0.26rem;
  color: #000;
  padding: 0.15rem 0;
}
.chooseHy {
  display: block;
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  border: 0;
  border-bottom: 0.02rem solid #f0f0f0;
  position: relative;
  color: #666;
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_rjiantou.png)
    no-repeat;
  background-position: 100% center;
  background-size: 0.3rem;
}
.main_content input {
  display: block;
  width: 100%;
  height: 0.8rem;
  font-size: 0.28rem;
  border: 0;
  color: #666;
  border-bottom: 0.02rem solid #f0f0f0;
}
.jieshao {
  width: 100%;
  background: #f5f5f5;
  border-radius: 0.16rem;
}
.jieshao textarea {
  height: 3rem;
  padding: 0.15rem;
  resize: none;
  display: block;
  width: 100%;
}
.mode1 {
  margin-bottom: 0.4rem;
}
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
}
.hyContent {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-radius: 0.16 rem 0.16rem 0 0;
}
.hangyeTitle {
  width: 100%;
  padding: 0.25rem 0.3rem;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.26rem;
}
.hangyeTitle img {
  display: block;
  width: 0.5rem;
}
.hyAll {
  width: 100%;
  padding: 0 0.3rem;
  height: 60vh;
  overflow: scroll;
  position: relative;
}
.hangyeli {
  margin: 0.3rem 0;
}
.cat_title {
  font-size: 0.28rem;
  color: #000;
}
.lispan {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: first baseline;
  align-items: center;
}
.lispan span {
  display: block;
  width: 22%;
  line-height: 0.7rem;
  background-color: #f5f5f5;
  border: 0.02rem solid #f0f0f0;
  font-size: 0.24rem;
  text-align: center;
  margin-right: 0.2rem;
  margin-top: 0.25rem;
  border-radius: 0.12rem;
}
.ackli {
  border: 0.02rem solid #ff4d19 !important;
  color: #ff4d19 !important;
}
.yesBtn {
  width: 90%;
  margin: 0 auto 0.2rem;
  line-height: 0.8rem;
  color: #fff;
  border-radius: 0.16rem;
  text-align: center;
  background-color: #ff4d19;
  font-size: 0.32rem;
}
.footerBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.15rem 0 0.25rem;
  background-color: #fff;
  z-index: 9;
}
.fabuBtn {
  width: 90%;
  margin: 0 auto;
  border-radius: 0.16rem;
  text-align: center;
  line-height: 0.9rem;
  background-color: #ff410a;
  font-size: 0.32rem;
  color: #fff;
}
.addc {
  width: 100%;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.addico {
  display: inline-block;
  position: relative;
}
.file {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.addico img {
  display: block;
  width: 0.6rem;
}
.addico p {
  display: block;
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 0.24rem;
  text-align: center;
  padding: 0;
  margin-bottom: 0.2rem;
}
.img {
  margin: 0 0.3rem;
  position: relative;
  font-size: 0;
}
.img img {
  display: block;
  width: 100%;
}
.img_btn {
  position: absolute;
  height: 0.8rem;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.3);
}
.img_btn .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  line-height: 0.8rem;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}
.img_btn .item span {
  font-size: 0.24rem;
  color: #fff;
  margin-left: 0.1rem;
}
.img_btn .item:first-child:after {
  position: absolute;
  right: 0;
  width: 0.015rem;
  height: 60%;
  content: "";
  background: #161010;
  border-radius: 0.1rem;
}
</style>
